export const environment = {
    production: false,
    apiUrl: 'https://devapi.cloudbalance.in/api/',
    ssoUrl: 'https://devsso.cloudbalance.in/',
    ssoApiUrl: 'https://devssoapi.cloudbalance.in/',
    megaMenuUrl: 'https://devmenu.cloudbalance.in',
    releaseNotesUrl: 'https://releasenotes.cloudbalance.in',
    silentLogoutUrls: [
        'https://devpurchase.cloudbalance.in/silent-logout',
        'https://devhrms.cloudbalance.in/silent-logout',
        'https://devsso.cloudbalance.in/silent-logout',
        'https://devsales.cloudbalance.in/silent-logout',
        'https://devexpense.cloudbalance.in/silent-logout',
        'https://dev.cloudbalance.in/silent-logout',
        'https://devdesk.cloudbalance.in/silent-logout'
    ]
    // apiUrl: 'http://localhost:3032/api/',
    // ssoUrl: 'https://devsso.cloudbalance.in/',
    // ssoApiUrl: 'https://devssoapi.cloudbalance.in/',
    // megaMenuUrl: 'https://devmenu.cloudbalance.in',
};
